export class Piece {
  // Champs existants
  name: string;
  status: string;
  projetName: string;
  category: string;
  type: string;
  nbPieces: number;
  nbPiscine: number;
  adresse: string;
  description: string;
  prixMdt: string;
  surface: string;
  photos: string[];
  Description: any; // (à corriger si nécessaire)

  // Champs arabes
  nameArab?: string;
  descriptionArab?: string;

  // Champs anglais – NEW
  nameEnglish?: string;
  descriptionEnglish?: string;

  // Autres
  nbChambres?: number;
  nbSallesDeBain?: number;
  pieceId?: number;
  projetId?: number;
  createdAt?: string;
  updatedAt?: string;
  videoUrl?: string | null;
}